export default __webpack_public_path__ + "static/portal/img/fig-1.f36fcaa.png";